import { updatesData } from '@/mocks/gossipData';

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            吃瓜快讯
          </h2>
          <p className="text-foreground-500 text-base">实时追踪 · 分秒必达</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-300 hidden sm:block"></div>

          <div className="space-y-6">
            {updatesData.map((item, i) => (
              <div key={i} className="flex gap-5 items-start group cursor-default">
                <div className="relative z-10 flex-shrink-0 hidden sm:flex">
                  <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                    <i className="ri-flashlight-line text-white text-sm"></i>
                  </div>
                </div>
                <div className="flex-1 bg-background-50 rounded-2xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-200 min-w-0">
                  <div className="flex items-center gap-3 mb-2 flex-wrap">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 font-medium group-hover:text-primary-600 transition-colors leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}